@if (lockedState) {
  <div class="full-screen no-events warn"></div>
  <div class="lock-circle no-events lock-hidden" #lockCircle>
    <mat-icon class="lock-icon no-events" aria-hidden="false" aria-label="Project locked" fontIcon="lock"></mat-icon>
  </div>
}